export const scrollToTop = (id: string): () => void => () => {
    const container = document.getElementById(id)
    if (container) {
        container.scrollIntoView({ behavior: 'smooth' })
    }
}